import { useRef, useState } from "react";
import { EnviaDatosANuevoServicio } from "../../Funciones/Funciones";
import useToken from "../login/useToken";
import classes from "./AjustesCambiaPWDyMail.module.css";
import { Slide, toast } from "react-toastify";

function CambiarPasswordyMail(props) {
  const MailRef = useRef();
  const ContraseñaRef = useRef();
  const { token } = useToken();
  const IDUsu = token.Id;
  const [isLoading, setIsLoading] = useState(false);

  const cambiaPWD = async (ev) => {
    ev.preventDefault();
    if (MailRef.current.value === "") {
      props.setTextoModal("Tienes que especificar un correo");
      props.setMuestraDialogoOK(true);
    } else {
      const datosN = {
        Mail: MailRef.current.value,
        IDUsuario: props.usuario.IDUsu,
        Contraseña: ContraseñaRef.current.value,
      };
      console.log("DatosN", datosN);
      EnviaDatosANuevoServicio(
        "CambiaDatosUsuario",
        datosN,
        respServ,
        setIsLoading,
        null,
        IDUsu,
      );
    }
  };

  function respServ(resp) {
    if (resp.Error === "SI") {
      props.setTextoModal("Error: " + resp.DESCERROR);
      props.setMuestraDialogoOK(true);
    } else {
      toast("datos guardados OK", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        transition: Slide,
      });
      props.setMostrarCambiarPWD(false);
    }
  }

  function cancelaCambioPWD(ev) {
    ev.preventDefault();
    props.setMostrarCambiarPWD(false);
  }

  /**************************************************************************************/
  /************************************ render ******************************************/
  /**************************************************************************************/
  //console.log(props);
  if (isLoading) {
    return (
      <section>
        <h1>Loading...</h1>
      </section>
    );
  }

  return (
    <section className={classes.modal}>
      <div className={classes.divBotones}>
        {props.nivel === 1 ? (
          <button className={classes.botones} onClick={(ev) => cambiaPWD(ev)}>
            <i className="fas fa-save"></i>
          </button>
        ) : null}
        <button className={classes.botones} onClick={cancelaCambioPWD}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <h1 className={classes.h1}>{props.usuario.Nombre}</h1>
      <hr className={classes.linea}></hr>
      <div className={classes.contRenglon}>
        <label className={classes.labelP}>Correo:</label>
        <input
          required
          type="text"
          ref={MailRef}
          className={classes.textareaNE}
          defaultValue={props.usuario.Mail}
        ></input>
      </div>
      <div className={classes.contRenglon}>
        <label className={classes.labelP}>Contraseña:</label>
        <input
          required
          type="text"
          ref={ContraseñaRef}
          placeholder="Nueva Contraseña"
          className={classes.textareaNE}
        ></input>
      </div>
    </section>
  );
}

export default CambiarPasswordyMail;
